import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { CustomListItemButtonProps } from "../types/components/customListItemButton";

const CustomListItemButton: React.FC<CustomListItemButtonProps> = ({
  icon,
  primaryText,
  sx,
  ...otherProps
}) => {
  return (
    <ListItemButton
      sx={{
        borderRadius: "8px",
        "&.Mui-selected": {
          color: "primary.main",
          "& svg": {
            color: "primary.main",
          },
        },
        "&:hover": {
          backgroundColor: "action.hover",
        },
        ...sx,
      }}
      {...otherProps}
    >
      {icon && (
        <ListItemIcon
          sx={{
            color: "inherit",
          }}
        >
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={primaryText}
        sx={{
          color: "inherit",
        }}
      />
    </ListItemButton>
  );
};

export default CustomListItemButton;
